<template>
  <SupportPageCard
    page-class="my-work"
    :title="languages.mylist_headerTitle"
    :show-lang-choose="true"
    @back="back"
  >
    <div v-if="messageData" class="message">
      <div class="message-date">
        <span class="line"></span>
        <span class="text">{{ messageData }}</span>
        <span class="line"></span>
      </div>
      <MessageItem
        v-for="(item, index) in messageList"
        :key="item.CREATE_TIME + '|' + index"
        :isService="!item.LOGIN_ACCOUNT && !item.FINGER_PRINT"
        :orderId="item.SUPPORT_ORDER_ID"
        :title="item.SUBJECT"
        :msg="item.MESSAGE"
        :imgList="item.SCREEN_PIC"
        :videoList="item.VIDEO_PATH"
        :videoDurations="item.VIDEO_DURATIONS"
        :videoPreviewPic="item.VIDEO_PREVIEW_PIC"
        :picAndVideoSequence="item.PIC_AND_VIDEO_SEQUENCE"
        :isLastMsg="index === messageList.length - 1"
        :isAiBot="!!item.AIBOT_MESSAGE"
        :aiBotMessage="item.AIBOT_MESSAGE"
        :isSupportCreateAibotOrder="!!item.IS_SUPPORT_CREATE_AIBOT_ORDER"
      ></MessageItem>
      <div v-if="resolved" class="message-resolve">
        <span class="line"></span>
        <span class="text">{{ languages.mywork_solvedText }}</span>
        <span class="line"></span>
      </div>
    </div>

    <template v-if="!loadingPage && !resolved" #footer>
      <div class="bottom">
        <transition
          name="evaluate-slide-up"
          appear
          @afterEnter="scrollToLatestMessage"
        >
          <div v-if="visibleServiceEvaluate" class="bottom-evaluate">
            <template v-if="visibleEvaluateResult">
              <van-icon
                name="cross"
                class="bottom-evaluate-close"
                @click="hideServiceEvaluate"
              />
              <div class="bottom-evaluate-result">
                <p>{{ languages.thankEvaluateTop }}</p>
                <p>{{ languages.thankEvaluateBottom }}</p>
              </div>
            </template>
            <template v-else>
              <van-icon
                name="cross"
                class="bottom-evaluate-close"
                @click="hideServiceEvaluate"
              />
              <p class="bottom-evaluate-title">
                {{ languages.isAgreeService }}
              </p>
              <div class="bottom-evaluate-choose">
                <a
                  v-for="item in evaluateArr"
                  :key="item.level"
                  href="javascript:;"
                  class="item"
                  :class="{ active: item.active }"
                  @click="evaluate(item)"
                >
                  <em class="item-icon" :class="item.icon"></em>
                  <span class="item-text">{{ item.langText }}</span>
                </a>
              </div>
            </template>
          </div>
        </transition>
        <div v-if="!workFileArr.length" class="bottom-bar">
          <van-button
            v-if="canEvaluate"
            class="bottom-bar-service"
            @click="showEvaluate"
          >
            <template #icon>
              <em class="iconfont icon-smile"></em>
            </template>
            {{ languages.serviceEvaluate }}
          </van-button>
          <van-button
            v-if="canInputMsg && isLogin && !hideEmail"
            class="bottom-bar-email"
            @click="emailRemind"
          >
            <template #icon>
              <em class="iconfont icon-email"></em>
            </template>
            <span class="bottom-bar-email-text">{{
              languages.emailRemind
            }}</span>
            <span
              class="bottom-bar-email-icon"
              :class="{ checked: recordBindEmail }"
            >
              <em class="iconfont icon-gou"></em>
            </span>
          </van-button>
        </div>
        <div v-else class="bottom-bar">
          <van-uploader
            v-model="workFileArr"
            :accept="accept"
            :max-count="workFileArr.length"
            :before-read="beforeReadImage"
            :after-read="afterReadImage"
            :preview-options="{
              closeable: true
            }"
            :before-delete="beforeDelete"
          >
            <template #preview-cover="{ customerType, url, duration }">
              <UploadVideoPreview
                v-if="customerType === 'video'"
                :firstFrameImage="url"
                :duration="duration"
              ></UploadVideoPreview>
            </template>
          </van-uploader>
        </div>
        <div v-if="canInputMsg" class="bottom-msg">
          <template v-if="canUseUpload">
            <IosUploadIcon
              v-if="showIOSUpload"
              :boolSmallSize="true"
              @click="iosUpload"
            ></IosUploadIcon>
            <van-uploader
              v-else
              v-model="workFileArr"
              :accept="accept"
              :before-read="beforeRead"
              :after-read="afterRead"
              :preview-image="false"
              :disabled="disabledUpload"
            >
              <van-button class="bottom-msg-file" :disabled="disabledUpload">
                <template #icon>
                  <em class="iconfont icon-camera"></em>
                </template>
              </van-button>
            </van-uploader>
          </template>
          <div class="bottom-msg-input">
            <van-field
              v-model="msgValue"
              @keyup.enter="sendMsg"
              :placeholder="languages.mywork_messageHolder"
              clearable
            />
          </div>
          <van-button
            class="bottom-msg-send"
            :loading="loadingSend"
            @click="sendMsg"
          >
            {{ languages.send }}
          </van-button>
        </div>
      </div>
    </template>
    <template #overlay>
      <EmailSubscribe
        ref="emailSheetRef"
        v-model="visibleEmailSubscribeSheet"
        :email="email"
        :loadingSubmit="loadingSubmit"
        :submitTip="languages.confirmWillReply"
        :submitSuccessTip="submitSuccessTip"
        @submit="submitEmail"
        @getInputEmail="getInputEmail"
      ></EmailSubscribe>
    </template>
  </SupportPageCard>
</template>

<script>
import { mapActions, mapState } from 'vuex';
import SupportPageCard from '@components/officialSupport/common/SupportPageCard.vue';
import MessageItem from '@components/officialSupport/MessageItem.vue';
import EmailSubscribe from '@components/officialSupport/EmailSubscribe.vue';
import UploadVideoPreview from '@components/officialSupport/UploadVideoPreview.vue';
import IosUploadIcon from '@components/officialSupport/IosUploadIcon.vue';
import formatDate from '@utiles/formatDate.js';
import emailSubscribe from '@mixins/officialSupport/emailSubscribe.js';
import fileUpload from '@mixins/officialSupport/fileUpload.js';
import {
  clickButton,
  locationType
} from '@plugins/biPoint/_configOfficialSupport';
import pointStayTime from '@mixins/officialSupport/pointStayTime';
import globalConfig from '@utiles/globalConfig';
import { getOrderVersionFromRouteQuery } from '@utiles/officialSupport';
export default {
  name: 'MyWork',
  mixins: [emailSubscribe, fileUpload, pointStayTime],
  data() {
    return {
      emailTimer: null,
      evaluateTimer: null,
      loadingPage: true, // 页面加载中
      canInputMsg: false, // 是否展示信息输入底栏
      loadingSend: false, // 正在发送消息
      msgValue: undefined, // 发送的消息内容
      canEvaluate: false, // 是否可以评价
      visibleServiceEvaluate: false, // 是否展示评价弹框
      visibleEvaluateResult: false, // 是否展示评价结果
      messageList: [] // 消息列表
    };
  },
  computed: {
    ...mapState({
      languages: state => state.languages,
      letter: state => state.languages?.mywork,
      isLogin: state => state.isLogin,
      hideEmail: state => state.hideEmail
    }),
    evaluateArr() {
      return [
        {
          icon: 'face-0',
          langText: this.languages.evaluateOne,
          active: false,
          level: 1
        },
        {
          icon: 'face-1',
          langText: this.languages.evaluateTwo,
          active: false,
          level: 2
        },
        {
          icon: 'face-2',
          langText: this.languages.evaluateThree,
          active: false,
          level: 3
        },
        {
          icon: 'face-3',
          langText: this.languages.evaluateFour,
          active: false,
          level: 4
        },
        {
          icon: 'face-4',
          langText: this.languages.evaluateFive,
          active: false,
          level: 5
        }
      ];
    },
    resolved() {
      if (this?.messageList?.length) {
        return this.messageList[0]?.STATUS == '4';
      } else {
        return false;
      }
    },
    disabledUpload() {
      // 去掉输入才能上传图片的限制
      return this.workFileArr.length >= this.maxCount;
      // 包含输入才能上传图片的限制和上传图片最大数量的限制
      // return (
      //   this.msgValue === void 0 ||
      //   this.msgValue?.trim() === '' ||
      //   this.workFileArr.length >= this.maxCount
      // );
    },
    workId() {
      return this.$route?.params?.workId;
    },
    // 列表带入的 order_version；深链无参时为 undefined，接口不传
    orderVersion() {
      return getOrderVersionFromRouteQuery(this.$route?.query);
    },
    messageData() {
      if (!this.messageList?.length) {
        return '';
      }
      const work = this.messageList[0];
      const date = new Date(work.CREATE_TIME * 1000);
      const time = formatDate(date, 'MM/dd/yyyy');
      return time;
    }
  },
  async mounted() {
    // 初始化时有DOM操作，mounted确保已挂载
    this.loadingPage = true;
    await this.initPage();
    this.loadingPage = false;
  },
  methods: {
    ...mapActions(['getWorkDetail', 'sendMessage', 'evaluation']),
    back() {
      if (globalConfig.isTiktokMiniProgram()) {
        this.$router.push('/mylist');
      } else {
        this.$router.go(-1);
      }
    },
    async initPage() {
      const detailParams = { workId: this.workId };
      if (this.orderVersion != null) {
        detailParams.order_version = this.orderVersion;
      }
      const data = await this.getWorkDetail(detailParams);
      if (data && data.length) {
        // 设置消息列表
        this.messageList = this.handleAiMessage(data);
        // 设置是否可以回复
        this.canInputMsg = data[0]?.IS_ABLE_TO_REPLY == 1;
        // 设置是否可以评分
        this.canEvaluate = data[0]?.IS_ABLE_TO_EVALUATE == 1;
        // 设置评分
        this.setEvaluate(data[0]?.EVALUATION);
        // 是否自动弹出客服弹窗：1不弹，2弹
        if (data[0]?.EVALUATE_POPUP == '2') {
          this.$nextTick(() => {
            this.showEvaluate();
          });
        }
      } else {
        this.messageList = [];
      }
      return Promise.resolve();
    },
    handleAiMessage(messageList) {
      messageList.map(item => {
        if (item.AIBOT_MESSAGE) {
          let aibot_message = '';
          try {
            aibot_message = JSON.parse(item.AIBOT_MESSAGE);
            const isCustomShowContent =
              !!aibot_message?.customShowContent || false;
            const content = (
              isCustomShowContent
                ? aibot_message?.customShowContent
                : aibot_message.content
            )
              .replace(/customCompName1/g, 'detail-page')
              .replace(/\n\n\[eva\]/g, '')
              .replace(
                /class="account-delete-link"/g,
                'style="color: #1989fa;"'
              );
            item.AIBOT_MESSAGE = {
              ...aibot_message,
              isAnswer: aibot_message.isAnswer || false,
              content: content,
              isAiBot: true
            };
          } catch (error) {
            console.log('error:', error);
          }
        }
      });
      console.log('messageList:', messageList);
      return messageList;
    },
    // 自动滚动消息列表到最新
    scrollToLatestMessage() {
      const messageItemEle = document.querySelector('.message-item:last-child');
      if (messageItemEle) {
        messageItemEle.scrollIntoView({
          behavior: 'smooth'
        });
      }
    },
    // 还原底栏占位符高度
    resetTabbarPlaceholderHeight() {
      if (this.tabbarPlaceholderHeight == 0) return;
      const tabbarContainerEle = this.$refs?.tabbar?.$el;
      if (!tabbarContainerEle) return;
      tabbarContainerEle.setAttribute(
        'style',
        `height: ${this.tabbarPlaceholderHeight}px;`
      );
    },
    // 发送信息
    async sendMsg() {
      clickButton({
        btnName: 'clickSemdMsg',
        locationKey: locationType.orderDetailPage
      });
      if (this.msgValue === void 0 || this.msgValue?.trim() === '') {
        this.$toast(this.languages.mywork_messageHolder);
        return;
      }
      try {
        this.loadingSend = true;
        await Promise.all(this.workFileArr.map(item => item.uploadingPromise));
        const imageFileArr =
          this.workFileArr?.filter(
            item => item.customerType === 'image' && item.status === 'done'
          ) || [];
        const videoFileArr =
          this.workFileArr?.filter(
            item => item.customerType === 'video' && item.status === 'done'
          ) || [];
        const data = await this.sendMessage({
          support_order_id: this.workId,
          ...(this.orderVersion != null
            ? { order_version: this.orderVersion }
            : {}),
          message: this.msgValue,
          pic: JSON.stringify(imageFileArr.map(item => item.url)),
          pic_compress: JSON.stringify(
            imageFileArr.map(item => item.isCompress)
          ),
          videoPath: JSON.stringify(videoFileArr.map(item => item.videoPath)),
          videoPreviewPic: JSON.stringify(videoFileArr.map(item => item.url)),
          videoDurations: JSON.stringify(
            videoFileArr.map(item => item.duration)
          ),
          picAndVideoSequence: JSON.stringify(
            this.workFileArr.map(item => {
              const url =
                item.customerType === 'image' ? item.url : item.videoPath;
              return url?.split('/')?.pop();
            })
          )
        });
        if (data && data.length) {
          this.messageList = data;
        }
        this.msgValue = undefined;
        this.workFileArr = [];
      } catch (e) {
        console.error(e);
      }
      this.loadingSend = false;
    },
    // 设置评分
    setEvaluate(level) {
      this.evaluateArr.forEach(item => {
        item.active = item.level == level;
      });
    },
    // 邮箱提醒
    emailRemind() {
      clearTimeout(this.emailTimer);
      if (this.recordBindEmail) {
        // 解绑
        this.$refs.emailSheetRef.showEmailUnSubscribe();
      } else {
        // 绑定
        this.$refs.emailSheetRef.showEmailInput();
      }
    },
    // 执行绑定或者解绑
    async submitEmail() {
      this.loadingSubmit = true;
      let handleFn = null;
      let successHandleFn = null;
      if (this.recordBindEmail) {
        handleFn = this.submitUnBindEmail;
        successHandleFn = this.$refs.emailSheetRef.showEmailUnSubscribeSucc;
      } else {
        handleFn = this.submitBindEmail;
        successHandleFn = this.$refs.emailSheetRef.showEmailSubscribeSucc;
      }
      try {
        // 判断是绑定还是解绑操作
        const data = await handleFn();
        this.submitSuccessTip = data?.msg || '';
        successHandleFn();
        this.emailTimer = setTimeout(() => {
          this.$refs.emailSheetRef.close();
        }, 3000);
      } catch (e) {
        console.log(e);
        this.$refs.emailSheetRef.close();
      }
      this.loadingSubmit = false;
    },
    // 客服评价
    showEvaluate() {
      this.visibleServiceEvaluate
        ? this.hideServiceEvaluate()
        : this.showServiceEvaluate();
    },
    // 展示客服评价
    showServiceEvaluate() {
      clickButton({
        btnName: 'clickOrderRate',
        locationKey: locationType.orderDetailPage
      });
      this.visibleServiceEvaluate = true;
    },
    // 隐藏客服评价
    hideServiceEvaluate() {
      clearTimeout(this.evaluateTimer);
      this.visibleServiceEvaluate = false;
      this.visibleEvaluateResult = false;
    },
    // 展示评价结果
    showEvaluateResult() {
      this.visibleEvaluateResult = true;
      this.evaluateTimer = setTimeout(() => {
        this.hideServiceEvaluate();
        this.visibleEvaluateResult = false;
      }, 3000);
    },
    // 评价
    async evaluate(item) {
      const oldEvaluateArr = JSON.stringify(this.evaluateArr);
      this.evaluateArr.forEach(evaluateItem => {
        evaluateItem.active = item.level === evaluateItem.level;
      });
      try {
        await this.evaluation({
          evaluation: item.level,
          support_order_id: this.workId,
          ...(this.orderVersion != null
            ? { order_version: this.orderVersion }
            : {})
        });
        this.showEvaluateResult();
      } catch (_e) {
        this.evaluateArr = JSON.parse(oldEvaluateArr);
      }
      // 评价完后请求消息列表，用于刷新评价状态
      this.initPage();
    }
  },
  components: {
    SupportPageCard,
    MessageItem,
    EmailSubscribe,
    UploadVideoPreview,
    IosUploadIcon
  }
};
</script>
<style lang="scss" scoped>
/* 评价面板展开动画（高度用 vw，避免固定 px 被 PC scale 放大） */
.evaluate-slide-up-enter-active,
.evaluate-slide-up-leave-active {
  will-change: transform;
  transition: all 0.5s ease;
  position: absolute;
  width: 100%;
  height: 51.794vw !important; // 216
  box-sizing: border-box;
}

.evaluate-slide-up-enter {
  height: 0 !important;
  opacity: 0;
  transform: translate3d(0, 0, 0);
}

.evaluate-slide-up-leave-to {
  height: 0 !important;
  opacity: 0;
  transform: translate3d(0, 0, 0);
}

@media screen and (orientation: landscape) {
  .evaluate-slide-up-enter-active,
  .evaluate-slide-up-leave-active {
    height: 20vh !important; // 216 / 1080 * 100
  }
}
</style>
